export default __webpack_public_path__ + "static/mirai-magical-school-winter-festival_16-2c14714b7f6befd1ebac8fef5591b350.png";